import React from "react";
import CustomModal from "../Modal/index";

interface ModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ExecutiveDetailsModal: React.FC<ModalProps> = ({ isOpen, onConfirm, onClose }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      content={
        <div className="flex flex-col items-center">
          <p className="text-[18px] font-[600] text-[#4B4B4B]">
            Are you sure you want to remove this form?
          </p>
          <div className="mt-4 flex gap-4">
            <button
              onClick={onConfirm}
              type="button"
              className="bg-red-500 rounded-[5px] h-[37px] w-[99px] text-white"
            >
              Yes
            </button>
            <button
              onClick={onClose}
              type="button"
              className="bg-gray-500 rounded-[5px] h-[37px] w-[99px] text-white"
            >
              No
            </button>
          </div>
        </div>
      }
      onClose={onClose}
    />
  );
};

export default ExecutiveDetailsModal;
